/**
 * Combines the account users with their resolved UUIDs.
 *
 * Every user is returned with all of their original fields preserved, plus a `uuid` field holding
 * the resolved value or `null` when it could not be resolved. This is account-wide user data meant
 * to be a single source of truth for the whole app — callers narrow it down themselves if needed.
 * Never throws: a missing or partial pairs map simply yields users with null UUIDs.
 *
 * @param {Array<Object>} usersList - Current account users (full user objects).
 * @param {Object} [pairs] - Map of PK_User → UUID (may be partial); missing/unmapped entries become null.
 * @returns {Array<Object>} The users with an added `uuid` field (string|null).
 */
export const buildAccountUsersList = (usersList, pairs = {}) => {
    if (!Array.isArray(usersList)) {
        return [];
    }

    return usersList.map((user) => ({
        ...user,
        uuid: pairs[String(user.PK_User)] ?? null,
    }));
};
